export default __webpack_public_path__ + "static/jenkins-5bb51ebd3ec7a28b9d3db45414cc9ac2.png";